module.exports = __webpack_public_path__ + "img/Logocrowdmarketing_WhiteMorado.ca08014d.png";